import React from 'react';
import { BloxButton } from 'styled_components/Common/BloxButton';
import { SuccessMessage, ErrorMessage } from 'utils/CommonConstants';

class PasswordResetSuccessNew extends React.Component {
	componentDidMount() {
		const { setModalContent, status, errorMessage } = this.props;
		const customErrorMessage = errorMessage ? errorMessage : ErrorMessage;

		const button = (
			<BloxButton
				className='buttons41'
				id='okay'
				text='OKAY'
				module='account'
				enabled={true}
				onClick={() => {}}
				cypressId='okay'
			/>
		);
		const text = status === 'CONFIRM_PASSWORD_SUCCESS' ? SuccessMessage : customErrorMessage;

		setModalContent('TIMEOUT_CLOSE', text, button);
	}

	render() {
		return <div />;
	}
}

export default PasswordResetSuccessNew;
